/**
 * The changes an impact assessment suggested, and the attorney's decision on
 * each, as the server owns them.
 */

import type {
  NotificationDecisionResponse,
  NotificationsResponse,
} from "@patent-studio/api-types";
import { get, post } from "@/services/api-client";

function notificationsPath(taskId: string): string {
  return `/tasks/${taskId}/notifications`;
}

function actionPath(taskId: string, actionId: string): string {
  return `${notificationsPath(taskId)}/actions/${actionId}`;
}

/** Every pending change in v0.28's cadence: only the earliest step surfaces. */
export function readNotifications(
  taskId: string,
): Promise<NotificationsResponse> {
  return get<NotificationsResponse>(notificationsPath(taskId));
}

/** Write the change as suggested, confirmed. */
export function acceptChange(
  taskId: string,
  actionId: string,
): Promise<NotificationDecisionResponse> {
  return post<NotificationDecisionResponse>(
    `${actionPath(taskId, actionId)}/accept`,
  );
}

/** Write the attorney's version of the change, confirmed. */
export function amendChange(
  taskId: string,
  actionId: string,
  text: string,
): Promise<NotificationDecisionResponse> {
  return post<NotificationDecisionResponse>(
    `${actionPath(taskId, actionId)}/amend`,
    { text },
  );
}

/** Leave the record as it is; what rested on the change is dismissed as moot. */
export function rejectChange(
  taskId: string,
  actionId: string,
): Promise<NotificationDecisionResponse> {
  return post<NotificationDecisionResponse>(
    `${actionPath(taskId, actionId)}/reject`,
  );
}
